import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const ExecutiveProfile = () => {
    const [executiveId, setExecutiveId] = useState(null)
    const [executiveDetails, setExecutiveDetails] = useState({})
    useEffect(() => {
        getExecutiveId();
        if (executiveId) {
            axios.get(`https://api.bakpoket.com/api/BDExecutive/get/${executiveId}`)
                .then(res => {
                    setExecutiveDetails(res.data)
                    // console.log(res.data)
                    // console.log(executiveDetails)
                })
                .catch(err => console.log(err))
        }
    }, [executiveId]);

    const getExecutiveId = () => {
        const data = localStorage.getItem('excutiveLogin')
        const parsedate = JSON.parse(data)
        if (parsedate) {
            setExecutiveId(parsedate.id)
        }
    }

    return (
        <Container1>
            <CardWrapper className="card border-0">
                {/* <CardBody className="card-body">
                    <h4>Executive Profile</h4>
                    <h6>User Name: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.userName}</small></h6>
                    <h6>Mobile Number: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.mobileNumber}</small></h6>
                    <h6>Alternate Number: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.alternateMobileNumber}</small></h6>
                    <h6>Email: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.email}</small></h6>
                    <h6>Dob: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.dob}</small></h6>
                    <h6>Address: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.address}</small></h6>
                    <h6>Referral Code: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.bdeCode}</small></h6>
                    <h6>Aadhar Number: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.aadharNumber}</small></h6>
                    <h6>Pan Number: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.panNumber}</small></h6>
                    <h6>Bank Name: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.bankName}</small></h6>
                    <h6>Branch Name: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.branchName}</small></h6>
                    <h6>Account Number: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.accountNumber}</small></h6>
                    <h6>IFSC Code: <small style={{color:'#8b8b8bcf'}}>{executiveDetails.ifscCode}</small></h6>
                </CardBody> */}
                <CardBody className="card-body">
                    <h4 className="d-flex justify-content-center mb-2">Executive Profile</h4>
                    <div className="row">
                        <div className="label">User Name</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.userName}</div>
                    </div>
                    <div className="row">
                        <div className="label">Mobile Number</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.mobileNumber}</div>
                    </div>
                    <div className="row">
                        <div className="label">Alternate Number</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.alternateMobileNumber}</div>
                    </div>

                    <div className="row">
                        <div className="label">Email</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.email}</div>
                    </div>

                    <div className="row">
                        <div className="label">Dob</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.dob}</div>
                    </div>

                    <div className="row">
                        <div className="label">Address</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.address}</div>
                    </div>

                    <div className="row">
                        <div className="label">Referral Code</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.bdeCode}</div>
                    </div>

                    <div className="row">
                        <div className="label">Aadhar Number</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.aadharNumber}</div>
                    </div>

                    <div className="row">
                        <div className="label">Pan Number</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.panNumber}</div>
                    </div>

                    <div className="row">
                        <div className="label">Bank Name</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.bankName}</div>
                    </div>

                    <div className="row">
                        <div className="label">Branch Name</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.branchName}</div>
                    </div>

                    <div className="row">
                        <div className="label">Account Number</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.accountNumber}</div>
                    </div>

                    <div className="row">
                        <div className="label">IFSC Code</div>
                        <div className="colon">:</div>
                        <div className="value">{executiveDetails.ifscCode}</div>
                    </div>
                    <div
                        className="my-2"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '12px',
                        }}
                    >
                        <div className="border p-2" style={{ height: '150px' }}>
                            <img
                                src={`data:image/png;base64,${executiveDetails.aadharCopy}`}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                }}
                                alt="Aadhar"
                            />
                        </div>

                        <div className="border p-2" style={{ height: '150px' }}>
                            <img
                                src={`data:image/png;base64,${executiveDetails.panCopy}`}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                }}
                                alt="PAN"
                            />
                        </div>
                    </div>

                    <div className="my-2 ">
                        <NavLink to={`/executiveUpdate/${executiveDetails.id}`}><button className="border-0 px-4 py-2 rounded fw-5 text-light" style={{ backgroundColor: 'rgb(239, 71, 102)' }}>Update</button></NavLink>
                    </div>
                </CardBody>

            </CardWrapper>
        </Container1>
    );
};

export default ExecutiveProfile;

/* ================= STYLES ================= */

const Container1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  
  width: 100%;
  height: 25rem;
  border-radius: 20px;
  @media(max-width:576px){
    padding: 0px;
  }
`;

const CardWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

const CardBody = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  padding: 1rem;

  white-space: nowrap;   /* REQUIRED for horizontal scroll */
  &::-webkit-scrollbar {
    width: 8px;   /* vertical scrollbar width */
    height: 8px;  /* horizontal scrollbar height */
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  /* Thumb */
  &::-webkit-scrollbar-thumb {
    background-color: #2a4157; /* scrollbar color */
    border-radius: 4px;
    border: 2px solid #f1f1f1; /* optional spacing around thumb */
  }

  /* Thumb hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #2a4157;
  }

  /* Optional: Corner where both scrollbars meet */
  &::-webkit-scrollbar-corner {
    background: #f1f1f1;
  }

  /* ===== Firefox support ===== */
  scrollbar-width: thin;
  scrollbar-color: #2a4157 #f1f1f1;
  .row {
    display: grid;
    grid-template-columns: 1.6fr 0.2fr 2.8fr; /* Label, colon, value */
    padding: 8px 0;
    border-bottom: 1px dotted #ccc;
    font-weight: 500;
    font-size: 0.9rem;
    min-width: 27rem;
  }

  .row:last-child {
    border-bottom: none;
  }

  .label {
    text-align: left;
    padding-right: 10px;
    color: #555;
  }

  .colon {
    text-align: center;
    color: #222;
  }

  .value {
    text-align: left;
    color: #635f5fcf;
    font-weight: 400;
  }
`;



